/**
 * Centralized column width/label config, mirroring the pattern in
 * src/screens/lcaIngredients/ingredientList/components/ingredientTable.columns.ts
 * — a single source of truth for the table's fixed layout instead of widths
 * scattered across each `<TableHead>`/`<TableCell>`.
 */
// Mirrors the Lovable prototype's grid (`src/pages/LcaProducts.tsx`): Register
// Number and Product Type ride along as subtext under the product name
// (with the Average Impact badge) rather than getting their own columns —
// see `ProductTableRow.tsx`.
export const productTableColumnClass = {
  name: "tw-w-[24%] tw-min-w-[12rem]",
  salesUnit: "tw-w-[20%] tw-min-w-[9rem]",
  climateImpact: "tw-w-[24%] tw-min-w-[11rem]",
  eanBarcode: "tw-w-[16%] tw-min-w-[8rem]",
  actions: "tw-w-[16%] tw-min-w-[7rem]"
} as const;

type ProductColumnKey = Exclude<keyof typeof productTableColumnClass, "actions">;

// `information` reproduces the legacy Sales Unit header tooltip copy from
// `ProductTableCol` (see src/config/tableColConstant.ts).
export const PRODUCT_TABLE_COLUMNS: ReadonlyArray<{
  key: ProductColumnKey;
  label: string;
  information?: string;
}> = [
  { key: "name", label: "Product Name" },
  {
    key: "salesUnit",
    label: "Sales Unit",
    information: "Click sales unit to see product mapping!"
  },
  { key: "climateImpact", label: "Climate Change Impact (kgCO2eq/kg)" },
  { key: "eanBarcode", label: "EAN Barcode" }
];
